import ErrorBoundary from './index';

const PageErrorBoundary = ({ children }: React.PropsWithChildren) => (
  <ErrorBoundary
    fallback={
      <div className="p-4 text-center text-red-600">
        Something went wrong while loading this page.
      </div>
    }
  >
    {children}
  </ErrorBoundary>
);

export default PageErrorBoundary;
